import moment from 'moment';
import empty from 'is-empty';
import {connect} from 'react-redux';
import classnames from 'classnames';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import InputRange from 'react-input-range';
import Autocomplete from 'react-google-autocomplete';

import SearchForMap from '../SearchForMap';
import * as AppConst from '../../../constants/App';
import FiltersAccordItem from '../FiltersAccordItem';
import * as ObjectConst from '../../../constants/Property';
import CustomDatepickerInput from '../../Base/CustomDatepickerInput';
import {
    setDateEnd,
    setAddress,
    setMinArea,
    setMaxArea,
    setPlaceId,
    findObjects,
    setTypeTerm,
    setMinPrice,
    setMaxPrice,
    setDateStart,
    setCountBeds,
    setAmenities,
    setRangeArea,
    setRangePrice,
    setCountGuests,
    setOurExclusive,
    setCountBedrooms,
    setTypeApartments,
    setCountBathrooms,
    setIsShowAllFilters,
    setIsShowAdvancedSearch,
    setMapDataFromPlaceAutoComplete
} from '../../../actions/Search';

const defaultProps = {
    setDateEnd: dateEndMoment => {
    },
    setAddress: address => {
    },
    findObjects: requestParams => {
    },
    setTypeTerm: name => {
    },
    setDateStart: dateStartMoment => {
    },
    setCountBeds: countBeds => {
    },
    setAmenities: name => {
    },
    setOurExclusive: isExclusive => {
    },
    setCountGuests: countGuests => {
    },
    setCountBedrooms: countBedrooms => {
    },
    setTypeApartments: name => {
    },
    setCountBathrooms: countBathrooms => {
    },
    setRangeArea: rangeArea => {
    },
    setRangePrice: rangePrice => {
    },
    setMinArea: minArea => {
    },
    setMaxArea: maxArea => {
    },
    setMinPrice: minPrice => {
    },
    setMaxPrice: maxPrice => {
    },
    setPlaceId: placeId => {
    },
    setIsShowAllFilters: isShowAllFilters => {
    },
    setIsShowAdvancedSearch: isShowAdvancedSearch => {
    }
};

class FiltersBlockHorizontal extends Component {
    state = {
        minArea: 0,
        maxArea: 1,
        minPrice: 0,
        maxPrice: 1,
        activeAccord: '',
        rangeArea: {
            min: 0,
            max: 1
        },
        rangePrice: {
            min: 0,
            max: 1
        }
    };

    componentDidMount() {
        this.setAddress(this.props);

        this.setState(this.getRangeAreaAndRangePrice(this.props));

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(nextProps) {
        this.setAddress(nextProps);
        this.setState(this.getRangeAreaAndRangePrice(nextProps));
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setAddress(props) {
        if (this.addressAutocomplete !== undefined && props.requestParams.address !== undefined) {
            this.addressAutocomplete.refs.input.value = props.requestParams.address;
        }
    };

    getRangeAreaAndRangePrice = props => {
        const newState = {};

        newState.rangeArea = {
            min: props.requestParams.minArea === undefined ? 0 : props.requestParams.minArea,
            max: props.requestParams.maxArea === undefined ? 1 : props.requestParams.maxArea
        };
        newState.rangePrice = {
            min: props.requestParams.minPrice === undefined ? 0 : props.requestParams.minPrice,
            max: props.requestParams.maxPrice === undefined ? 1 : props.requestParams.maxPrice
        };
        newState.minArea = newState.rangeArea.min;
        newState.maxArea = newState.rangeArea.max;
        newState.minPrice = newState.rangePrice.min;
        newState.maxPrice = newState.rangePrice.max;

        return newState;
    };

    handleDateStartChange(date) {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            this.props.setDateStart(date);
        }
    }

    handleDateEndChange(date) {
        if (!date.isBefore(moment().subtract(1, 'days')) && !date.isBefore(this.props.dateStartMoment)) {
            this.props.setDateEnd(date);
        }
    }

    handleTypeTermClick = value => {
        this.props.setTypeTerm(value);
    };

    handleTypeApartmentsCheck = value => {
        this.props.setTypeApartments(value);
    };

    handleCountGuestsCheck = value => {
        this.props.setCountGuests(value);
    };

    handleCountBedroomsCheck = value => {
        this.props.setCountBedrooms(value);
    };

    handleCountBathroomsCheck = value => {
        this.props.setCountBathrooms(value);
    };

    handleCountBedsCheck = value => {
        this.props.setCountBeds(value);
    };

    handleOurExclusiveCheck = event => {
        this.props.setOurExclusive(event.currentTarget.checked);
    };

    handleAmenitiesCheck(event) {
        this.props.setAmenities(event.target.name);
    }

    handleFindClick(event) {
        event.preventDefault();

        this.props.findObjects(this.props.requestParams);
    }

    handleAddressChange(place) {
        this.props.setMapDataFromPlaceAutoComplete(place);
    }

    handleRangePriceChange(rangePrice) {
        this.props.setRangePrice(rangePrice);
    }

    handleRangeAreaChange(rangeArea) {
        this.props.setRangeArea(rangeArea);
    }

    handleMinMaxChange(event) {
        const newState = {};
        const value = event.target.value;
        const valueInt = parseInt(event.target.value, 10);
        const {
            requestParams,
            searchPage: {
                rangeAreaSettings: {
                    min: minAreaSettings,
                    max: maxAreaSettings
                },
                rangePriceSettings: {
                    min: minPriceSettings,
                    max: maxPriceSettings
                }
            }
        } = this.props;

        switch (event.target.name) {
            case 'minArea':
                newState.minArea = value;
                if (valueInt < requestParams.maxArea && valueInt >= minAreaSettings) {
                    this.props.setMinArea(valueInt);
                }
                break;
            case 'maxArea':
                newState.maxArea = value;
                if (valueInt > requestParams.minArea && valueInt <= maxAreaSettings) {
                    this.props.setMaxArea(valueInt);
                }
                break;
            case 'minPrice':
                newState.minPrice = value;
                if (valueInt < requestParams.maxPrice && valueInt >= minPriceSettings) {
                    this.props.setMinPrice(valueInt);
                }
                break;
            case 'maxPrice':
                newState.maxPrice = value;
                if (valueInt > requestParams.minPrice && valueInt <= maxPriceSettings) {
                    this.props.setMaxPrice(valueInt);
                }
                break;
            default:
                break;
        }
        this.setState(newState);
    }

    toggleIsShowAllFilters = event => {
        event.preventDefault();

        this.props.setIsShowAllFilters(!this.props.isShowAllFilters);
    };

    toggleIsShowAdvancedSearch = () => {
        this.props.setIsShowAdvancedSearch(!this.props.isShowAdvancedSearch);
    };

    setActiveAccord = (event, activeAccord) => {
        event.preventDefault();

        this.setState(prevState => ({
            activeAccord: prevState.activeAccord === activeAccord ? '' : activeAccord
        }));
    };

    clearActiveAccord = () => {
        if (this.state.activeAccord !== '') {
            this.setState({
                activeAccord: ''
            });
        }
    };

    handleClickOutside = event => {
        if (
            this.filtersAccord &&
            !this.filtersAccord.contains(event.target) &&
            this.filtersAccord2 &&
            !this.filtersAccord2.contains(event.target)
        ) {
            this.clearActiveAccord();
        }
    };

    render() {
        const {
            i18n,
            code,
            countBeds,
            typeTerms,
            countGuests,
            dateEndMoment,
            countBedrooms,
            typeApartments,
            countBathrooms,
            dateStartMoment,
            configTypeTerms,
            configCountBeds,
            isShowAllFilters,
            configCountGuests,
            configCountBedrooms,
            isShowAdvancedSearch,
            configCountBathrooms,
            configTypeApartmentsRent,
            searchPage: {
                rangeAreaSettings: {
                    min: minAreaSettings,
                    max: maxAreaSettings
                },
                rangePriceSettings: {
                    min: minPriceSettings,
                    max: maxPriceSettings
                }
            }
        } = this.props;

        return (
            <div className="filters_block clearfix horizontal-format">
                <div className="other_filter">
                    <div className="filter-line dates-line">
                        <div className="date-pickers">
                            <div className="to-date">
                                {code !== undefined && <DatePicker
                                    locale={code}
                                    selected={dateStartMoment}
                                    dateFormat={AppConst.DATE_FORMAT}
                                    onChange={::this.handleDateStartChange}
                                    calendarClassName="search-rental_datepicker date-start"
                                    dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                        'react-datepicker__day--disabled' :
                                        date.isSame(dateStartMoment) ?
                                            'selecting-range-start' :
                                            undefined}
                                    customInput={
                                        <CustomDatepickerInput
                                            customClassName="text-field"
                                            placeholderText={i18n['search.dateStartPlaceholder']}
                                        />
                                    }
                                />}
                            </div>
                            <div className="from-date">
                                {code !== undefined && <DatePicker
                                    locale={code}
                                    selected={dateEndMoment}
                                    openToDate={dateStartMoment}
                                    dateFormat={AppConst.DATE_FORMAT}
                                    onChange={::this.handleDateEndChange}
                                    calendarClassName="search-rental_datepicker date-end"
                                    dayClassName={
                                        date => date.isBefore(moment().subtract(1, 'days')) ||
                                        date.isBefore(dateStartMoment) ?
                                            'react-datepicker__day--disabled' :
                                            date.isSame(dateEndMoment) ?
                                                'selecting-range-start' :
                                                undefined
                                    }
                                    customInput={
                                        <CustomDatepickerInput
                                            customClassName="text-field"
                                            placeholderText={i18n['search.dateEndPlaceholder']}
                                        />
                                    }
                                />}
                            </div>
                        </div>

                        <label className="checkbox">
                            <input
                                type="checkbox"
                                onChange={this.handleOurExclusiveCheck}
                                checked={this.props.requestParams.rangeTypeValues.includes(ObjectConst.RANGE_TYPE.EXCLUSIVE)}
                            />
                            <span>{i18n['search.ourExclusive']}</span>
                        </label>

                        <label className="main-search">
                            {this.props.configuration.isGoogleApiInit && <Autocomplete
                                className="text-field"
                                placeholder={i18n['search.autocompletePlaceholder']}
                                types={[]}
                                ref={autocomplete => {
                                    this.addressAutocomplete = autocomplete;
                                }}
                                onPlaceSelected={place => {
                                    ::this.handleAddressChange(place);
                                }}
                            />}
                        </label>

                    </div>


                    <div className="price">
                        <div className="filter-line range-line">
                            <div className="price-box">
                                <span>{`${i18n['search.price']}, ${this.props.currency}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minPrice"
                                            value={this.state.minPrice}
                                            className="minCost filter05-min"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxPrice"
                                            value={this.state.maxPrice}
                                            className="maxCost filter05-max"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            minValue={minPriceSettings}
                                            maxValue={maxPriceSettings}
                                            value={this.state.rangePrice}
                                            onChange={::this.handleRangePriceChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="price-box">
                                <span>{`${i18n['search.area']}, ${i18n['objectPage.areaUnit']}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minArea"
                                            value={this.state.minArea}
                                            className="minCost filter06-min"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxArea"
                                            value={this.state.maxArea}
                                            className="maxCost filter06-max"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeArea"
                                            minValue={minAreaSettings}
                                            maxValue={maxAreaSettings}
                                            value={this.state.rangeArea}
                                            onChange={::this.handleRangeAreaChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={this.toggleIsShowAdvancedSearch}
                                className={classnames('more_custom', {
                                    'active': isShowAdvancedSearch
                                })}
                            >
                                <span>
                                    {isShowAdvancedSearch ? i18n['search.hideFilters'] : i18n['search.advancedSearch']}
                                </span>
                            </div>
                            <button onClick={::this.handleFindClick} className="btn">
                                {i18n['search.find']}
                            </button>

                            <SearchForMap />
                        </div>

                        {isShowAdvancedSearch && <div className="more_filter">
                            {this.props.configuration.object.amenities.map((item) =>
                                <label key={item.value} className="checkbox">
                                    <input
                                        name={item.value}
                                        onChange={::this.handleAmenitiesCheck}
                                        checked={this.props.requestParams.amenities.includes(item.value)}
                                        type="checkbox" />
                                    <span>{item.title}</span>
                                </label>
                            )}
                        </div>}
                    </div>
                </div>
                {!empty(i18n) && <div
                    className="filters_accord"
                    onMouseLeave={this.clearActiveAccord}
                    ref={ref => {
                        this.filtersAccord = ref;
                    }}
                >
                    <FiltersAccordItem
                        elements={configTypeTerms}
                        elementsForChecked={typeTerms}
                        title={i18n['search.typeTerm']}
                        elemOnClick={this.handleTypeTermClick}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_TERM}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_TERM)}
                    />

                    <FiltersAccordItem
                        elements={configTypeApartmentsRent}
                        elementsForChecked={typeApartments}
                        title={i18n['search.typeApartmentsRental']}
                        elemOnClick={this.handleTypeApartmentsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_APARTMENT}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_APARTMENT)}
                    />

                    <FiltersAccordItem
                        isCountElements={true}
                        elements={configCountGuests}
                        countForChecked={countGuests}
                        title={i18n['search.countGuests']}
                        elemOnClick={this.handleCountGuestsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_GUEST}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_GUEST)}
                    />

                    <FiltersAccordItem
                        isCountElements={true}
                        elements={configCountBedrooms}
                        countForChecked={countBedrooms}
                        title={i18n['search.countBedrooms']}
                        elemOnClick={this.handleCountBedroomsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BEDROOMS}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BEDROOMS)}
                    />

                    <FiltersAccordItem
                        isCountElements={true}
                        elements={configCountBathrooms}
                        countForChecked={countBathrooms}
                        title={i18n['search.countBathrooms']}
                        elemOnClick={this.handleCountBathroomsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BATHROOMS}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BATHROOMS)}
                    />

                    <FiltersAccordItem
                        isCountElements={true}
                        elements={configCountBeds}
                        countForChecked={countBeds}
                        title={i18n['search.countBeds']}
                        elemOnClick={this.handleCountBedsCheck}
                        isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BEDS}
                        headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BEDS)}
                    />

                    <div className="tablet_box_sidebar">
                        <div className="center">
                            <a
                                href=""
                                onClick={this.toggleIsShowAllFilters}
                                className={isShowAllFilters ?
                                    'btn transparent all_filters opened' :
                                    'btn transparent all_filters'}
                            >
                                <span>{i18n['search.allFilters']}</span>
                                <p>{i18n['search.hideFilters']}</p>
                            </a>
                            <SearchForMap />
                        </div>
                    </div>
                </div>}
                <div className="mobile_box">
                    <div className="box-top">
                        <a
                            href=""
                            onClick={this.toggleIsShowAllFilters}
                            className={isShowAllFilters ?
                                'btn transparent all_filters opened' :
                                'btn transparent all_filters'}
                        >
                            <span>{i18n['search.allFilters']}</span>
                            <p>{i18n['search.hideFilters']}</p>
                        </a>
                    </div>
                    <div className="box-bottom">
                        <SearchForMap />
                        <button onClick={::this.handleFindClick} className="btn">
                            {i18n['search.find']}
                        </button>
                    </div>
                </div>

                <div
                    className={classnames('open_filters clearfix', {
                        'opened': isShowAllFilters
                    })}
                >
                    {!empty(i18n) && <div
                        className="filters_accord"
                        onMouseLeave={this.clearActiveAccord}
                        ref={ref => {
                            this.filtersAccord2 = ref;
                        }}
                    >
                        <FiltersAccordItem
                            elementsForChecked={typeTerms}
                            title={i18n['search.typeTerm']}
                            elemOnClick={this.handleTypeTermClick}
                            elements={this.props.configuration.object.typeTerms}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_TERM}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_TERM)}
                        />

                        <FiltersAccordItem
                            elements={configTypeApartmentsRent}
                            elementsForChecked={typeApartments}
                            title={i18n['search.typeApartmentsRental']}
                            elemOnClick={this.handleTypeApartmentsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.TYPE_APARTMENT}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.TYPE_APARTMENT)}
                        />

                        <FiltersAccordItem
                            isCountElements={true}
                            elements={configCountGuests}
                            countForChecked={countGuests}
                            title={i18n['search.countGuests']}
                            elemOnClick={this.handleCountGuestsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_GUEST}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_GUEST)}
                        />

                        <FiltersAccordItem
                            isCountElements={true}
                            elements={configCountBedrooms}
                            countForChecked={countBedrooms}
                            title={i18n['search.countBedrooms']}
                            elemOnClick={this.handleCountBedroomsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BEDROOMS}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BEDROOMS)}
                        />

                        <FiltersAccordItem
                            isCountElements={true}
                            elements={configCountBathrooms}
                            countForChecked={countBathrooms}
                            title={i18n['search.countBathrooms']}
                            elemOnClick={this.handleCountBathroomsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BATHROOMS}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BATHROOMS)}
                        />

                        <FiltersAccordItem
                            isCountElements={true}
                            elements={configCountBeds}
                            countForChecked={countBeds}
                            title={i18n['search.countBeds']}
                            elemOnClick={this.handleCountBedsCheck}
                            isActiveAccord={this.state.activeAccord === ObjectConst.FIELDS.COUNT_BEDS}
                            headerOnClick={event => this.setActiveAccord(event, ObjectConst.FIELDS.COUNT_BEDS)}
                        />
                    </div>}

                    <div className="other_filter">
                        <div className="filter-line range-line">
                            <div className="price-box">
                                <span>{`${i18n['search.price']}, ${this.props.currency}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minPrice"
                                            value={this.state.minPrice}
                                            className="minCost filter05-min"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxPrice"
                                            value={this.state.maxPrice}
                                            className="maxCost filter05-max"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            minValue={minPriceSettings}
                                            maxValue={maxPriceSettings}
                                            value={this.state.rangePrice}
                                            onChange={::this.handleRangePriceChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="price-box">
                                <span>{`${i18n['search.area']}, ${i18n['objectPage.areaUnit']}:`}</span>
                                <div className="filter_mask clearfix">
                                    <div className="filter-block-slidefilter">
                                        <input
                                            name="minArea"
                                            value={this.state.minArea}
                                            className="minCost filter06-min"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                        <input
                                            name="maxArea"
                                            value={this.state.maxArea}
                                            className="maxCost filter06-max"
                                            onChange={::this.handleMinMaxChange}
                                        />
                                    </div>
                                    <div className="range-container">
                                        <InputRange
                                            name="rangeArea"
                                            minValue={minAreaSettings}
                                            maxValue={maxAreaSettings}
                                            value={this.state.rangeArea}
                                            onChange={::this.handleRangeAreaChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex">
                            <label className="checkbox">
                                <input type="checkbox" />
                                <span>{i18n['search.ourExclusive']}</span>
                            </label>
                            <div
                                onClick={this.toggleIsShowAdvancedSearch}
                                className={classnames('more_custom', {
                                    'active': isShowAdvancedSearch
                                })}
                            >
                                <span>
                                    {isShowAdvancedSearch ? i18n['search.hideFilters'] : i18n['search.advancedSearch']}
                                </span>
                            </div>
                        </div>


                        <div className="price">
                            <button onClick={::this.handleFindClick} className="btn">
                                {i18n['search.find']}
                            </button>
                            {isShowAdvancedSearch && <div className="more_filter">
                                {this.props.configuration.object.amenities.map((item) =>
                                    <label key={item.value} className="checkbox">
                                        <input
                                            name={item.value}
                                            onChange={::this.handleAmenitiesCheck}
                                            checked={this.props.requestParams.amenities.includes(item.value)}
                                            type="checkbox" />
                                        <span>{item.title}</span>
                                    </label>
                                )}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FiltersBlockHorizontal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    searchPage: state.searchPage,
    configuration: state.configuration,
    code: state.languages.currentLanguage.code,
    currency: state.configuration.main.currency,
    dateEndMoment: state.searchPage.dateEndMoment,
    requestParams: state.searchPage.requestParams,
    dateStartMoment: state.searchPage.dateStartMoment,
    isShowAllFilters: state.searchPage.isShowAllFilters,
    typeTerms: state.searchPage.requestParams.typeTerms,
    countBeds: state.searchPage.requestParams.countBeds,
    configTypeTerms: state.configuration.object.typeTerms,
    configCountBeds: state.configuration.object.countBeds,
    countGuests: state.searchPage.requestParams.countGuests,
    configCountGuests: state.configuration.object.countGuests,
    isShowAdvancedSearch: state.searchPage.isShowAdvancedSearch,
    countBedrooms: state.searchPage.requestParams.countBedrooms,
    typeApartments: state.searchPage.requestParams.typeApartments,
    configCountBedrooms: state.configuration.object.countBedrooms,
    countBathrooms: state.searchPage.requestParams.countBathrooms,
    configCountBathrooms: state.configuration.object.countBathrooms,
    configTypeApartmentsRent: state.configuration.object.typeApartmentsRent
});

const mapDispatchToProps = {
    setDateEnd,
    setAddress,
    setMinArea,
    setMaxArea,
    setPlaceId,
    findObjects,
    setTypeTerm,
    setMinPrice,
    setMaxPrice,
    setDateStart,
    setCountBeds,
    setAmenities,
    setRangeArea,
    setRangePrice,
    setCountGuests,
    setOurExclusive,
    setCountBedrooms,
    setTypeApartments,
    setCountBathrooms,
    setIsShowAllFilters,
    setIsShowAdvancedSearch,
    setMapDataFromPlaceAutoComplete
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersBlockHorizontal);


// WEBPACK FOOTER //
// ./src/components/Search/Rental/FiltersBlockHorizontal.js